/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrderItemType,
    OrderItemTypeFromJSON,
    OrderItemTypeFromJSONTyped,
    OrderItemTypeToJSON,
} from './OrderItemType';

/**
 * 
 * @export
 * @interface SalesFinanceReportProps
 */
export interface SalesFinanceReportProps {
    /**
     * 
     * @type {Date}
     * @memberof SalesFinanceReportProps
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof SalesFinanceReportProps
     */
    processed: Date;
    /**
     * 
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    order_id: string;
    /**
     * 
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    contact_id: string;
    /**
     * 
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    contact_full_name: string;
    /**
     * 
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    program_attendee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    attendee_full_name?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    receipt_number: string;
    /**
     * 
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    include_fee: string;
    /**
     * 
     * @type {OrderItemType}
     * @memberof SalesFinanceReportProps
     */
    type: OrderItemType;
    /**
     * Amount collected from sales
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    amount_gross_sale: string;
    /**
     * Amount returned in sales
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    amount_returned: string;
    /**
     * Sum of discounted amounts
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    amount_discounted: string;
    /**
     * Sum of included fees
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    amount_included_fee: string;
    /**
     * Sum of excluded fees
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    amount_excluded_fee: string;
    /**
     * Amount collected from sales after refunds
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    amount_net_sale: string;
    /**
     * Total amount of taxes collected
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    amount_gross_tax: string;
    /**
     * Total amount of taxes collected after refunds
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    amount_net_tax: string;
    /**
     * Sum of the item cost, taxes, discounts, and fees (if passed on to customer)
     * @type {string}
     * @memberof SalesFinanceReportProps
     */
    amount_total: string;
}

export function SalesFinanceReportPropsFromJSON(json: any): SalesFinanceReportProps {
    return SalesFinanceReportPropsFromJSONTyped(json, false);
}

export function SalesFinanceReportPropsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesFinanceReportProps {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'created': (new Date(json['created'])),
        'processed': (new Date(json['processed'])),
        'order_id': json['order_id'],
        'contact_id': json['contact_id'],
        'contact_full_name': json['contact_full_name'],
        'program_attendee_id': !exists(json, 'program_attendee_id') ? undefined : json['program_attendee_id'],
        'attendee_full_name': !exists(json, 'attendee_full_name') ? undefined : json['attendee_full_name'],
        'receipt_number': json['receipt_number'],
        'description': json['description'],
        'include_fee': json['include_fee'],
        'type': OrderItemTypeFromJSON(json['type']),
        'amount_gross_sale': json['amount_gross_sale'],
        'amount_returned': json['amount_returned'],
        'amount_discounted': json['amount_discounted'],
        'amount_included_fee': json['amount_included_fee'],
        'amount_excluded_fee': json['amount_excluded_fee'],
        'amount_net_sale': json['amount_net_sale'],
        'amount_gross_tax': json['amount_gross_tax'],
        'amount_net_tax': json['amount_net_tax'],
        'amount_total': json['amount_total'],
    };
}

export function SalesFinanceReportPropsToJSON(value?: SalesFinanceReportProps | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'created': (value.created.toISOString()),
        'processed': (value.processed.toISOString()),
        'order_id': value.order_id,
        'contact_id': value.contact_id,
        'contact_full_name': value.contact_full_name,
        'program_attendee_id': value.program_attendee_id,
        'attendee_full_name': value.attendee_full_name,
        'receipt_number': value.receipt_number,
        'description': value.description,
        'include_fee': value.include_fee,
        'type': OrderItemTypeToJSON(value.type),
        'amount_gross_sale': value.amount_gross_sale,
        'amount_returned': value.amount_returned,
        'amount_discounted': value.amount_discounted,
        'amount_included_fee': value.amount_included_fee,
        'amount_excluded_fee': value.amount_excluded_fee,
        'amount_net_sale': value.amount_net_sale,
        'amount_gross_tax': value.amount_gross_tax,
        'amount_net_tax': value.amount_net_tax,
        'amount_total': value.amount_total,
    };
}

